import { TableViewColumnDefinition } from '@components/UI-Components/StandardTableView/models/TableViewColumnDefinition'
import { IOrderManagementTableData } from '@services/wholesale/OrderManagementService'
import React from 'react'
import Typography from '@components/std-components/Typography'
import * as css from './CancelProductComponentService.css'
import Tooltip from '@material-ui/core/Tooltip'

class CancelProductComponentService {
  getBoldLabelComponent = (
    rowData: IOrderManagementTableData,
    columnDefinition: TableViewColumnDefinition
  ) => {
    return (
      <Tooltip title={rowData[columnDefinition.node.key]} placement='bottom'>
        <div className={css.rowWrapper}>
          <Typography variant={'body1'} classes={css.bodyTextBold}>
            {rowData[columnDefinition.node.key]}
          </Typography>
        </div>
      </Tooltip>
    )
  }

  getLabelComponent = (
    rowData: IOrderManagementTableData,
    columnDefinition: TableViewColumnDefinition
  ) => {
    return (
      <Tooltip title={rowData[columnDefinition.node.key]} placement='bottom'>
        <div className={css.rowWrapper}>
          <Typography variant={'body2'} classes={css.bodyText}>
            {rowData[columnDefinition.node.key]}
          </Typography>
        </div>
      </Tooltip>
    )
  }
}

export const cancelProductComponentService = new CancelProductComponentService()
